module.exports = __webpack_public_path__ + "static/media/stars-less-1920.7b29052e.webp";